import { useTkv2HandleIconClick } from '@aloft/toolkit-frontend/src/components/ReferenceBar/useTkv2HandleIconClick.ts';

import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarItem } from './Tkv2ReferenceBarItem.tsx';

export const Tkv2HelpDrawerItem = () => {
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const handleIconClick = useTkv2HandleIconClick();

  const isSelected = selectedDataSheet === 'help-drawer' && referenceViewOpen;

  return (
    <Tkv2ReferenceBarItem
      id="page_guide"
      label="Page Guide"
      icon="information"
      isSelected={isSelected}
      onClick={() => handleIconClick('help-drawer')}
    />
  );
};
